import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';

import {NotificationsPopover} from './NotificationsPopover';
import {useNotificationsMenu} from '../../hooks/notifications/useNotificationsMenu';

export function NotificationsBell(): JSX.Element {
  const {
    anchorEl,
    open,
    count,
    notifications,
    loading,
    isError,
    isMarkingAllRead,
    onOpen,
    onClose,
    onMarkAllRead,
    onArchive,
    onNotificationClick,
  } = useNotificationsMenu();

  return (
    <>
      <IconButton aria-label="Notifications" color="primary" onClick={onOpen}>
        <Badge badgeContent={count} max={99} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <NotificationsPopover
        anchorEl={anchorEl}
        open={open}
        count={count}
        notifications={notifications}
        loading={loading}
        isError={isError}
        isMarkingAllRead={isMarkingAllRead}
        onClose={onClose}
        onMarkAllRead={onMarkAllRead}
        onArchive={onArchive}
        onNotificationClick={onNotificationClick}
      />
    </>
  );
}
